// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SC20b","icon":"styles_icon__1TrI0"};